import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualCustomerPage } from './manual-customer.page';

const routes: Routes = [
  {
    path: '',
    component: ManualCustomerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualCustomerPageRoutingModule {}
